const WHATSAPP_NUMBER = "543764868906";
const DEFAULT_MESSAGE = "Hola, Coressen quiero hablar con un asesor";

export const getWhatsAppLink = (message: string = DEFAULT_MESSAGE): string => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const WHATSAPP_URL = getWhatsAppLink();
